<template>
  <div class="w-100 text-center py-5">
    <loader></loader>
  </div>
</template>

<script>
  import { mapMutations,mapGetters } from 'vuex';
  export default {
    computed:{
      ...mapGetters(['getCompanyType','getMerchant'])
    },
    mounted(){
      let clone_data = {}
      if(this.getCompanyType == 'MERCHANT'){
        clone_data = this.$deepCopy(this.getMerchant)
      }
      this.resetAllDataHotel()
      this.resetAllDataConcierge()
      this.resetAllDataMarketing()
      this.resetAllDataRestaurant()
      this.resetAllDataTicket()
      this.resetAllDataGeneral('with_user')
      setTimeout(()=>{
        let url = '/'
        if(clone_data.id){
          url = `/${clone_data.code}`
        }
        this.$router.push(url)
      },1000)
    },
    methods:{
      ...mapMutations([
				'resetAllDataHotel',
				'resetAllDataMarketing',
				'resetAllDataRestaurant',
				'resetAllDataTicket',
				'resetAllDataGeneral',
        'resetAllDataConcierge'
			])
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/general/ClearData.vue